import { Badge } from "@chakra-ui/react";
import { NewOrderEarSide } from "../stores/order.store";

const EarBadge = ({
	side,
	mr,
}: {
	side: NewOrderEarSide;
	mr?: string | number;
}) => {
	if (side === NewOrderEarSide.LEFT) {
		return (
			<Badge
				lineHeight="21px"
				fontSize="14px"
				px="8px"
				rounded="xl"
				backgroundColor="#EFF8FF"
				color="#175CD3"
				border={"solid 1px"}
				borderColor="#B2DDFF"
				mr={mr}
			>
				OG
			</Badge>
		);
	}
	return (
		<Badge
			lineHeight="21px"
			fontSize="14px"
			px="8px"
			rounded="xl"
			backgroundColor="#FEF3F2"
			color="#B42318"
			border={"solid 1px"}
			borderColor="#FECDCA"
			mr={mr}
		>
			OD
		</Badge>
	);
};

export default EarBadge;
